module.exports = __webpack_public_path__ + "img/footer_qrcode_icon.5e86b500.svg";